import TilesCarousel from './TilesCarousel';
import './TilesCarousel.scss';

export default TilesCarousel;